import React from 'react'
import { useTranslation } from 'react-i18next'
import { css } from '@linaria/core'
import { Paragraph, Separator, LayoutBand, H4, H6 } from '@fs/zion-ui'
import Head, { Title } from '@fs/zion-head'
import Link from './Link'
import GenericErrorImage from './images/GenericErrorImage'

export default function GenericError() {
  const [t] = useTranslation()

  return (
    <>
      <Title>{t('error-page.title', 'Internal Server Error')}</Title>
      <Head>
        <meta name="prerender-status-code" content="500" />
      </Head>
      <LayoutBand maxWidth="sm">
        <div
          data-testid="generic-error"
          className={css`
            text-align: center;
          `}
        >
          <GenericErrorImage />
          <H4 centered data-testid="error-heading">
            {t('error-page.title', 'Internal Server Error')}
          </H4>
          <Paragraph centered>
            {t('error-page.body', 'We are sorry, but the page you are trying to access has an error.')}
          </Paragraph>
          <Separator size="md" />
          <H6 centered>{t('not-found.whats-next', "What's Next")}</H6>
          <Separator size="sm" />
          <Link external to="/">
            {t('error-page.option-home', 'Return to the home page')}
          </Link>
          <Separator size="xxs" />
          <Paragraph centered size="sm">
            {t('not-found.option-other', 'Or choose a new activity from the main site menu.')}
          </Paragraph>
        </div>
      </LayoutBand>
    </>
  )
}
